export default "__VITE_ASSET__CeQp9goj__"